import axios from "@/axios.js"

export default {
  createCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createCategory", data)
        .then((response) => {
          commit('ADD_CATEGORIES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateCategory", data)
        .then((response) => {
          commit('UPDATE_CATEGORY', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  viewCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewCategory", data)
        .then((response) => {
          commit('SET_CATEGORIES', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  viewCategoryWithoutPaginate({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewCategory", data)
        .then((response) => {
          commit('SET_CATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  viewCategoryWithoutPaginate({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewCategory", data)
        .then((response) => {
          commit('SET_CATEGORIES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteCategory", data)
        .then((response) => {
          commit('DELETE_CATEGORY', data.id)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  /////////////////////////////
  /// 
  getAllQuestions({ commit }, data) {
    return new Promise((resolve, reject) => {
      var page = localStorage.getItem('currentPage');
  console.log(page);  
      axios.post("/api/admin/viewQuestions?page="+page, data)
        .then((response) => {
          // this.currentPage = res.data.current_page
                    // localStorage.setItem('lastPage', response.data.data.last_page);
          commit('SET_QUESTIONS', response.data.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  viewQuestion({ commit }, questionId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewQuestion/"+questionId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateQuestion({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateQuestion", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createQuestion({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createQuestion", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllQuestionsWithoutPagi({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewQuestions", data)
        .then((response) => {
          commit('SET_QUESTIONS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteQuestion({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteQuestion", data)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },


  viewTest({ commit }, testId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTest/"+testId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getAllTests({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTests", data)
        .then((response) => {
          commit('SET_TESTS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createTest({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createTest", data)
        .then((response) => {
          commit('ADD_TEST', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateTest({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateTest", data)
        .then((response) => {
          commit('UPDATE_TEST', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteTest({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteTest", data)
        .then((response) => {
          commit('DELETE_TEST', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },

  getAllPackages({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTestPackages", data)
        .then((response) => {
          commit('SET_PACKAGES', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  viewPackage({ commit }, packageId) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTestPackages/"+packageId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createPackage({ commit }, packageData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createTestPackage", packageData)
        .then((response) => {
          commit('ADD_PACKAGE', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updatePackage({ commit }, packageData) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateTestPackage", packageData)
        .then((response) => {
          commit('UPDATE_PACKAGE', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deletePackage({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteTestPackage", data)
        .then((response) => {
          commit('DELETE_PACKAGE', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },

  viewBanner({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewBanner", data)
        .then((response) => {
          commit('SET_BANNERS', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  createBanner({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createBanner", data)
        .then((response) => {
          commit('ADD_BANNER', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateBanner({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateBanner", data)
        .then((response) => {
          commit('UPDATE_BANNER', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteBanner({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteBanner", data)
        .then((response) => {
          commit('DELETE_BANNER', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },


  viewAdvertisment({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewAdvertisment", data)
        .then((response) => {
          commit('SET_ADVERTISMENTS', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  createAdvertisment({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createAdvertisment", data)
        .then((response) => {
          commit('ADD_ADVERTISMENT', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateAdvertisment({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateAdvertisment", data)
        .then((response) => {
          commit('UPDATE_ADVERTISMENT', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteAdvertisment({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteAdvertisment", data)
        .then((response) => {
          commit('DELETE_ADVERTISMENT', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },

  viewSign({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewSign", data)
        .then((response) => {
          commit('SET_SIGNS', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  createSign({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createSign", data)
        .then((response) => {
          commit('ADD_SIGN', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateSign({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateSign", data)
        .then((response) => {
          commit('UPDATE_SIGN', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteSign({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteSign", data)
        .then((response) => {
          commit('DELETE_SIGN', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },

  viewSignCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewSignCategory", data)
        .then((response) => {
          commit('SET_SIGN_CATEGORYS', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  viewSignCategoryWithOutPagi({ commit }) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewSignCategory", {avoid_pagi : true})
        .then((response) => {
          commit('SET_SIGN_CATEGORYS', response.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  createSignCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createSignCategory", data)
        .then((response) => {
          commit('ADD_SIGN_CATEGORY', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateSignCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateSignCategory", data)
        .then((response) => {
          commit('UPDATE_SIGN_CATEGORY', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteSignCategory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteSignCategory", data)
        .then((response) => {
          commit('DELETE_SIGN_CATEGORY', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  viewTheory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/viewTheory", data)
        .then((response) => {
          commit('SET_THEORIES', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  createTheory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/createTheory", data)
        .then((response) => {
          commit('ADD_THEORY', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  updateTheory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/updateTheory", data)
        .then((response) => {
          commit('UPDATE_THEORY', response.data.data)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
  deleteTheory({ commit }, data) {
    return new Promise((resolve, reject) => {
      axios.post("/api/admin/deleteTheory", data)
        .then((response) => {
          commit('DELETE_THEORY', data.id)
          resolve(response)
        })
        .catch((error) => { 
          reject(error.response) 
        })
    })
  },
}
